import { render, staticRenderFns } from "./FeatureComparisonTable.vue?vue&type=template&id=59d14ca5&scoped=true"
import script from "./FeatureComparisonTable.vue?vue&type=script&lang=js"
export * from "./FeatureComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureComparisonTable.vue?vue&type=style&index=0&id=59d14ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d14ca5",
  null
  
)

export default component.exports